import { useState } from 'react';

// Libs
import Skeleton from 'react-loading-skeleton';

interface ImageLoaderProps {
  src: string;
  alt: string;
  className?: string;
}

function ImageLoader({ src, alt, className }: ImageLoaderProps) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={className}>
      <img
        className="h-full w-full object-cover"
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        style={loaded ? {} : { position: 'absolute' }}
        loading="lazy"
      />
      {!loaded && <Skeleton width={300} height={300} />}
    </div>
  );
}

export default ImageLoader;
